/*
 * Copyright (c) 2025-2026 Aegis AO Soft LLC and Alexander Orlov.
 * Confidential and proprietary. Author: Alexander Orlov.
 */

import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import StorefrontPage from './pages/StorefrontPage';
import CarBookingPage from './pages/CarBookingPage';
import ModelBookingPage from './pages/ModelBookingPage';
import SiteSettingsPage from './pages/SiteSettingsPage';
import MyBookingsPage from './pages/MyBookingsPage';
import MobileLicenseUpload from './pages/MobileLicenseUpload';
import AboutPage from './pages/AboutPage';
import TermsPage from './pages/TermsPage';
import ContactPage from './pages/ContactPage';
import { useTenant } from './contexts/TenantContext';

export default function App() {
  const { isLoading, isMainDomain } = useTenant();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center opacity-50">Loading…</div>
    );
  }

  return (
    <Routes>
      {/* Standalone phone page (opened from the desktop QR) — no site chrome. */}
      <Route path="/m/license/:sessionId" element={<MobileLicenseUpload />} />
      <Route
        path="*"
        element={
          <Layout>
            <Routes>
              {/* Tenant domains get the full storefront; the main domain is the global marketplace. */}
              <Route path="/" element={isMainDomain ? <HomePage /> : <StorefrontPage />} />
              <Route path="/car/:carId" element={<CarBookingPage />} />
              <Route path="/model/:make/:model" element={<ModelBookingPage />} />
              <Route path="/my-bookings" element={<MyBookingsPage />} />
              <Route path="/settings" element={<SiteSettingsPage />} />
              {/* Tenant storefront info pages (also reachable on the main domain; they read tenant data). */}
              <Route path="/about" element={<AboutPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </Layout>
        }
      />
    </Routes>
  );
}
